import React from 'react';

const Card = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-lg";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <div ref={ref} className={classes} {...props} />
  );
});
Card.displayName = "Card";

const CardHeader = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "flex flex-col space-y-1.5 p-4 md:p-6";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <div ref={ref} className={classes} {...props} />
  );
});
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "text-xl md:text-2xl font-semibold leading-none tracking-tight text-gray-900 dark:text-white";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <h3 ref={ref} className={classes} {...props} />
  );
});
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "text-sm text-gray-600 dark:text-gray-400";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <p ref={ref} className={classes} {...props} />
  );
});
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "p-4 md:p-6 pt-0";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <div ref={ref} className={classes} {...props} />
  );
});
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "flex items-center p-4 md:p-6 pt-0";
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <div ref={ref} className={classes} {...props} />
  );
});
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }; 